import React, { useState } from 'react';
import { format } from 'date-fns';

import WpDayPicker from '../WpDayPicker';
import WpDayPickerDropdown from '../WpDayPickerDropdown';

const DayPickerDocs = () => {
  const Basic = () => {
    const today = new Date();
    const [date, setDate] = useState<Date | undefined>(today);

    return (
      <div>
        <p>You chose: {format(date, 'PPP')}</p>
        <WpDayPicker onSelect={setDate} />
      </div>
    );
  };

  const Dropdown = () => {
    return <WpDayPickerDropdown />;
  };

  return (
    <div>
      <h5 className="mb-3">Basic</h5>
      <Basic />
      <h5 className="mt-3 mb-3">WpDayPickerDropdown</h5>
      <Dropdown />
    </div>
  );
};

export default DayPickerDocs;
